import merge from 'lodash/merge';
import { mapRanges } from 'nmr-processing';
export function initiateRanges(options, spectrum) {
    return merge({
        values: [],
        options: {
            sum: undefined,
            isSumConstant: true,
            sumAuto: true,
        },
    }, options.ranges, {
        values: mapRanges(options?.ranges?.values || [], spectrum),
    });
}
